import axios from 'axios'
import { Notify, Dialog, Toast } from 'vant';
import store from '@/store'
import { getToken } from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import Cookies from "js-cookie";

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

console.log(Cookies.get("systemHost"));
// 创建axios实例
// const service = axios.create({
//   // axios中请求配置有baseURL选项，表示请求URL公共部分
//   //baseURL: process.env.VUE_APP_BASE_API,
//   baseURL: Cookies.get("systemHost"),
//   // 超时
//   timeout: 100000
// })
const service = axios.create({
  timeout: 100000
});

// 在每个请求前动态修改 baseURL
service.interceptors.request.use(
  (config) => {
    const systemHost = Cookies.get("systemHost"); // 每次请求时都读取最新的值
    config.baseURL = systemHost;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// request拦截器
service.interceptors.request.use(config => {
  Toast.loading({
    message: '加载中...',
    forbidClick: true,
    duration: 0
  });
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  if (getToken() && !isToken) {
    config.headers['token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?';
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName];
      var part = encodeURIComponent(propName) + "=";
      if (value !== null && typeof (value) !== "undefined") {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            url += subPart + encodeURIComponent(value[key]) + "&";
          }
        } else {
          url += part + encodeURIComponent(value) + "&";
        }
      }
    }
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  Toast.clear();
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200;
  // 获取错误信息
  const msg = errorCode[code] || res.data.msg || errorCode['default']
  if (code === 401 || code === "410") {
    Dialog.confirm({
      title: '系统提示',
      message: '登录状态已过期，您可以继续留在该页面，或者重新登录',
      confirmButtonText: '重新登录',
      cancelButtonText: '取消'
    })
      .then(() => {
        store.dispatch('LogOut').then(() => {
          try {
            let loginUrl = Cookies.get("_Login_url");
            if(loginUrl && loginUrl.indexOf("homesteadLogin") !== -1)
            {
              window.location.href = loginUrl;
              return;
            }
          } catch (e) { console.log(e); }
          if (window.location.href.indexOf("homesteadSurvey") != -1) {
            window.location.href = '/homesteadLogin';
          } else {
            window.location.href = '/homesteadLogin';
            /*window.location.href = '/index';*/
          }
        })
      })
  } else if (code === 500) {
    Dialog.alert({ type: 'warning', message: msg });
    return Promise.reject(new Error(msg))
  } else if (code !== 200 && code != "SUCCESS") {
    Dialog.alert({ type: 'warning', message: msg });
    return Promise.reject('error')
  } else {
    return res.data
  }
},
  error => {
    console.log('err' + error)
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    }
    else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    }
    else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Toast.clear();
    // Message({
    //   message: message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    Dialog.alert({ type: 'warning', message: message });
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js